// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class BxRecommenderController {
   $scope: any
   bxService: any
   config: any

   constructor($scope: any, bxService: any, config: any) {
      this.getResolverLink = this.getResolverLink.bind(this)
      this.$scope = $scope
      this.bxService = bxService
      this.$scope.ceil = Math.ceil
      this.$scope.bxService = this.bxService
      this.config = config.data.bxRecommender

      this.$scope.getResolverLink = this.getResolverLink
      this.$scope.closeBX = this.bxService.close
   }

   getResolverLink(doc: any) {
      if (this.config.linkResolver && doc.open_url) {
         const baseUrl = this.config.linkResolver.trim().replace(/\?$/, "")
         const delim = baseUrl.includes("?") ? "&" : "?"
         return `${baseUrl}${delim}${doc.open_url}`
      } else {
         return ""
      }
   }
}

BxRecommenderController.$inject = ['$scope', 'bxRecommenderService', 'configService']

angular.module('summonApp.controllers')
   .controller('BxRecommenderCtrl', BxRecommenderController)
